import createIcon from '../../createIcon';

/**
 * @component @name SendToMobile
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUuNSAxN0gxNy41VjIxQzE3LjUgMjIuMSAxNi42IDIzIDE1LjUgMjNINS41QzQuNCAyMyAzLjUgMjIuMSAzLjUgMjFWM0MzLjUgMS45IDQuNCAxLjAxIDUuNSAxLjAxTDE1LjUgMUMxNi42IDEgMTcuNSAxLjkgMTcuNSAzVjdIMTUuNVY2SDUuNVYxOEgxNS41VjE3Wk0yMC41IDEyTDE2LjUgOFYxMUgxMS41VjEzSDE2LjVWMTZMMjAuNSAxMloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SendToMobile = createIcon('SendToMobile', [
  [
    'path',
    {
      d: 'M15.5 17H17.5V21C17.5 22.1 16.6 23 15.5 23H5.5C4.4 23 3.5 22.1 3.5 21V3C3.5 1.9 4.4 1.01 5.5 1.01L15.5 1C16.6 1 17.5 1.9 17.5 3V7H15.5V6H5.5V18H15.5V17ZM20.5 12L16.5 8V11H11.5V13H16.5V16L20.5 12Z',
      key: '3d4bwg',
    },
  ],
]);

export default SendToMobile;
